import { EN_REGION_PLACE_TYPE_STR } from '@yanolja-rnd/cx-joy-sdm/dist/sapporo/region/legacy/enum/EN_REGION_PLACE_TYPE';
import { ITicket } from '@yanolja-rnd/cx-joy-sdm/dist/sapporo/ticket/interface/ITicket';
import { action, observable } from 'mobx';
import { identity, prop } from 'ramda';
import { createContext } from 'react';

import { ILeisureCrossSellListPayload } from '../models/Leisure/interfaces/payloads/ILeisureRegionCrossSellListPayload';
import { LeisureActions } from '../models/Leisure/LeisureActions';
import { LeisureRequestBuilder } from '../models/Leisure/LeisureRequestBuilder';
import { ILeisureCrossSellListProps } from '../pages/leisure/cross-sell';
import { nullish } from '../utils/yambda';

export class LeisureCrossSellListStore {
  placeType: EN_REGION_PLACE_TYPE_STR;
  region: number;

  @observable
  isError: boolean = false;
  @observable
  title: string;
  @observable
  hasMore: boolean;
  @observable
  list: ITicket[] = [];

  @observable
  isLoading: boolean = false;

  page: number;
  readonly limit: number = 20;

  private readonly actions = new LeisureActions(LeisureRequestBuilder);

  constructor(props: ILeisureCrossSellListProps) {
    if (!props.data) {
      this.isError = true;
    } else {
      this.title = props.data.title;
      this.hasMore = props.data.hasMore;
      this.list = props.data.items;
    }

    this.placeType = props.placeType;
    this.region = props.region;
    this.page = 1;
  }

  @action.bound
  async onRetry(): Promise<void> {
    const res = this.actions.regionCrossSellList({
      query: {
        placeType: this.placeType,
        region: this.region,
        page: this.page,
        limit: this.limit,
      },
    });

    const data = (await res).map(prop('data')).caseOf<ILeisureCrossSellListPayload | null>({
      left: nullish,
      right: identity,
    });

    if (!data) {
      this.isError = true;
      this.list = [];
      this.title = '이 주변 놀거리';
      return;
    }

    this.isError = false;
    this.title = data.title;
    this.hasMore = data.hasMore;
    this.list = data.items;
    this.page = 1;
  }

  @action.bound
  async onLoadMore(): Promise<void> {
    if (!this.hasMore || this.isLoading) {
      return;
    }

    this.isLoading = true;

    const res = this.actions.regionCrossSellList({
      query: {
        placeType: this.placeType,
        region: this.region,
        page: this.page + 1,
        limit: this.limit,
      },
    });

    this.list = (await res).map(prop('data')).caseOf<ITicket[]>({
      left: () => {
        this.hasMore = false;
        return this.list;
      },
      right: data => {
        this.page = this.page + 1;
        this.hasMore = data.hasMore;
        return this.list.concat(data.items);
      },
    });

    this.isLoading = false;
  }
}

export const LeisureCrossSellListStoreCtx = createContext<LeisureCrossSellListStore>(null!);
